import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Select from "@insite/mobius/Select";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import MapPIMFields from "@thos/Components/MapPIMFields";
import UploadPIMFile from "@thos/Components/UploadPIMFile";
import { PimUploadModel } from "@thos/Models/PimUploadModel";
import { getAvailablePimJobFiles, getMappingTypes, processMappedData, uploadDataFileAndGetMappings } from "@thos/Services/EtlToolService";
import React, { useContext, useEffect } from "react";
import { css } from "styled-components";

interface Props {
    stuff: string;
}

const EtlTool = ({ stuff }: Props) => {

    const [uploadCancelled, setUploadCancelled] = React.useState(false);
    const [isUploading, setIsUploading] = React.useState(false);
    const [isUploaded, setIsUploaded] = React.useState(false);
    const [mappings, setMappings] = React.useState([{}] as PimUploadModel[]);
    const [mappingSelection, setMappingSelection] = React.useState({} as SafeDictionary<string>);
    const [mapName, setMapName] = React.useState("");
    const [mapType, setMapType] = React.useState("PIM");
    const [sourceFile, setSourceFile] = React.useState<string>();
    const [availableSourceFiles, setAvailableSourceFiles] = React.useState<string[]>();
    const [file, setFile] = React.useState<File>();
    const toasterContext = useContext(ToasterContext);

    const processFileHandler = () => {
        if (sourceFile) {
            setIsUploading(true);
            uploadDataFileAndGetMappings(sourceFile).then((mappings: PimUploadModel[]) => {
                setMappings(mappings);
                setIsUploaded(true);
            }).finally(() => {
                setIsUploading(false);
            });
        }
    };

    const fileUploadChangeHandler = (event: { target: { files: File[]; }; }) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
    };

    const setIsUploadingHandler = (isUploading: boolean) => {
        setIsUploading(isUploading);
    };

    const loadExistingMappings = () => {
        getMappingTypes().then((value: string[]) => {});
    };

    const setSelectedMappings = (mapName: string) => {};

    const startProcessingJob = (value: any, onComplete?: () => void) => {
        if (!sourceFile) {
            return;
        }
        const updatedMappings = {} as SafeDictionary<any>;
        for (const key in mappingSelection) {
            const value = mappingSelection[key]?.toString();
            if (value !== undefined && (value.includes("Attribute") || value.includes("Specification"))) {
                if (updatedMappings[value] as string[] === undefined) {
                    updatedMappings[value] = [];
                }
                (updatedMappings[value] as string[]).push(key);
            }
            else if (value !== undefined) {
                updatedMappings[value] = key;
            }
        }
        const processData = { "DataMap": updatedMappings, "FileName": sourceFile }

        setIsUploading(true);
        toasterContext.addToast({
            body: (<Typography as="p">{siteMessage("PimFileUpload_Processing_File_Start_Message")}</Typography>),
            messageType: "info",
            timeoutLength: 10000,
        });
        processMappedData(processData)
            .then((o: string) => {
                toasterContext.addToast({
                    body: (<Typography as="p">{siteMessage("PimFileUpload_Processing_File_Success_Message")}</Typography>),
                    messageType: "success",
                    timeoutLength: 5000,
                });
            })
            .catch((reason: any) => {
                toasterContext.addToast({
                    body: (<Typography as="p">{siteMessage("PimFileUpload_Processing_File_Failure_Message")}</Typography>),
                    messageType: "danger",
                    timeoutLength: 10000,
                });
            })
            .finally(() => {
                setIsUploading(false);
            });
    };


    useEffect(() => {
        getAvailablePimJobFiles().then((result: string[]) => {
            setAvailableSourceFiles(result);
        });
    }, []);

    return (
        <LoadingOverlay loading={isUploading}>
            <StyledWrapper {...{ css: css`display: flex; flex-direction: column; gap: 10px;` }}>
                <StyledWrapper>
                    {availableSourceFiles && availableSourceFiles.length > 0 && (
                        <Select
                            label={translate("Source File")}
                            value={sourceFile}
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                                setSourceFile(event.target.value);
                            }}>
                                <option key="empty" value="">
                                </option>
                            {availableSourceFiles.map((o:string) => (
                                <option key={o} value={o}>
                                    {o}
                                </option>
                            ))}
                        </Select>
                    )}
                </StyledWrapper>
                <StyledWrapper>
                    {sourceFile &&  (
                        <Button disabled={isUploading} onClick={processFileHandler}>
                            {translate("Generate Mapping Options")}
                        </Button>
                    )}
                </StyledWrapper>
                <StyledWrapper>
                    {isUploaded &&
                        <MapPIMFields
                            processMappingsHandler={startProcessingJob}
                            mappings={mappings}
                            mappingSelection={mappingSelection}
                            mapName={mapName}
                            fieldOptions={mappings[0].fieldOptions} />}
                </StyledWrapper>
            </StyledWrapper>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: EtlTool,
    definition: {
        group: "ETL" as any,
        allowedContexts: ["EtlToolPage" as any],
    },
};

export default widgetModule;
